import { useEffect } from "react";

import { Button, PromoBanner } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { DunningsBanner, DunningsBannerImage } from "app/components/Dunnings/DunningsBanner/DunningsBannerStyled";
import {
    NT_DUNNINGS_EVENT_NAME,
    DUNNINGS_INLINE_BANNER_CTA_LOCATION,
    DUNNINGS_UPDATE_BILLING_EVENT_SUB_SUB_NAME,
} from "app/components/Dunnings/dunningsConstants";
import { ProjectsDunningsBannerText } from "app/components/Dunnings/ProjectsDunningsBanner/ProjectsDunningsBannerText";
import { useDunnings } from "app/components/hooks/useDunnings";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";
import { useTranslation } from "pro-features/components/WithTranslation";

export const ProjectsDunningsBanner = () => {
    const { isInRetryProcess, onDunningsButtonClicked, isLastPaymentFailedWarning, numberOfFailedPayments } =
        useDunnings();
    const translate = useTranslation();

    useEffect(() => {
        allTrackers.dispatchTrackEvent(
            "banner",
            "show",
            `${NT_DUNNINGS_EVENT_NAME}/${DUNNINGS_INLINE_BANNER_CTA_LOCATION}/${numberOfFailedPayments}`,
        );
    }, [numberOfFailedPayments]);

    if (!isInRetryProcess) {
        return null;
    }

    return (
        <DunningsBanner isLastPaymentFailedWarning={isLastPaymentFailedWarning}>
            <Flex
                data-automation="dunnings-section-banner"
                justifyContent="space-between"
                width="100%"
                alignItems="center"
                gap="20px"
            >
                <Flex
                    gap="20px"
                    alignItems="center"
                >
                    <DunningsBannerImage
                        src={AssetsService.assetUrl("images/dunnings/payment_denied2.svg")}
                        alt="Payment denied"
                    />
                    <PromoBanner.Content>
                        <PromoBanner.Title>
                            <Text fontVariant="subtitle1">{translate("dunnings.projects.banner.title")}</Text>
                        </PromoBanner.Title>
                        <PromoBanner.Description>
                            <ProjectsDunningsBannerText />
                        </PromoBanner.Description>
                    </PromoBanner.Content>
                </Flex>

                <Button
                    type="outlined"
                    onClick={() =>
                        onDunningsButtonClicked(
                            `${NT_DUNNINGS_EVENT_NAME}/${DUNNINGS_INLINE_BANNER_CTA_LOCATION}/${DUNNINGS_UPDATE_BILLING_EVENT_SUB_SUB_NAME}`,
                            "billing",
                        )
                    }
                >
                    {translate("dunnings.projects.banner.button_text")}
                </Button>
            </Flex>
        </DunningsBanner>
    );
};
